import { render } from "./SettingsEmailsTemplatesWarningEditionModal.vue?vue&type=template&id=cae7905c"
import script from "./SettingsEmailsTemplatesWarningEditionModal.vue?vue&type=script&lang=js"
export * from "./SettingsEmailsTemplatesWarningEditionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__